export const RequestPropertyIds = {
  Organization: 'Organization',
  Department: 'Department',
  Category: 'Category',
  Project: 'Project',
  EvaluationDate: 'EvaluationDate',
  DefaultQuoteValidity: 'DefaultQuoteValidity',
  Workflow: 'Workflow',
  BusinessUnit: 'Business Unit',
  PublishedAt: 'PublishedAt',
  AwardedAt: 'AwardedAt',
  CoManagers: 'CoManagers',
  TransitionReason: 'TransitionReason',
  SimUrl: 'SimUrl',
  // DCSP properties
  EventSubType: 'EventSubType',
  HasAlignmentDocument: 'HasAlignmentDocument',
  NonAlignmentReason: 'NonAlignmentReason',
  SSJLink: 'SSJLink',
  RepricingSourceEventId: 'RepricingSourceEventId',
  RepricingComments: 'RepricingComments',
  RenewalSourceEventId: 'RenewalSourceEventId',
  RenewalComments: 'RenewalComments',
  BuildId: 'BuildId',
  BuildIdComments: 'BuildIdComments',
  EstimatedAmount: 'EstimatedAmount',
  Sites: 'Sites',
  Categories: 'Categories',
  SubCategory: 'SubCategory',
  SubCategories: 'SubCategories',
  Regions: 'Regions',
  Overview: 'Overview',
  ProcessDetails: 'ProcessDetails',
  // RFI properties
  CorrespondenceType: 'CorrespondenceType',
  ApprovalLink: 'ApprovalLink',
  Subject: 'Subject',
  Body: 'Body',
  BodyText: 'BodyText'
};

export const ResponsePropertyIds = {
  AcknowledgementStatus: 'AcknowledgementStatus',
  QuoteValidity: 'QuoteValidity'
};

export const CommonConstants = {
  UNSET_REGION_VALUE: 'UNSET'
};

export const QuestionPropertyIds = {
  MessageTo: 'MessageTo',
  ParticipationConfirmation: 'ParticipationConfirmation',
  MessageContent: 'MessageContent'
};

export const TransitionRequestModalBlurbs = {
  recall: {
    warning: 'Proceeding with this action will terminate the request with all its offers and can no longer be ordered.'
  },
  discard: {
    warning: 'Proceeding with this action will discard the request. Suppliers will no longer be able to respond.'
  },
  complete: {
    warning: 'Proceeding with this action will complete the request. Suppliers will no longer be able to respond.'
  }
};
